import { getStoneOverlayProjectId } from "../config/stoneOverlayDemo";
import { useSavedMaskOverlay } from "../hooks/useSavedMaskOverlay";

/**
 * Headless (renders nothing) loader for the rdn60 renal-stone overlay demo.
 *
 * Mount it in the case viewer with the open study's id. For a study in the
 * cherry-picked allowlist it fetches the saved labeling mask + longest
 * dimension and renders the mask across the MPR panes; for any other study it
 * is a no-op (no labeling fetch fires). The labeling panel is untouched.
 */
export function StoneOverlayLoader({ studyId }: { studyId: string | null | undefined }) {
  const projectId = getStoneOverlayProjectId(studyId);
  const bareUid = projectId && studyId ? studyId.split("::")[0] : null;
  useSavedMaskOverlay(bareUid, projectId);
  return null;
}
